import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView, View } from "@frui.ts/views/dist";
import classNames from "classnames";
import { observer, Observer } from "mobx-react-lite";
import React from "react";
import CallCenterViewModel from "viewModels/callCenter/callCenterViewModel";
import { searchBarContext } from "./search/searchBarView";
import AlertWithIcon from "views/common/alertWithIcon";

export const CallCenterView: ViewComponent<CallCenterViewModel> = observer(({ vm }) => {
  const searchClassNames = classNames("mb-4", "mb-lg-0", "col-12", { "col-lg-8 col-xxl-9": vm.allowWrite });
  return (
    <div className="px-0">
      {vm.displayVehicleRegisterWarning && vm.vehicleSearchStatus && (
        <AlertWithIcon variant="danger" className="danger">
          {vm.translateVehicleSearchStatus(vm.vehicleSearchStatus)}
        </AlertWithIcon>
      )}
      <div className="mb-4 equal row">
        <div className={searchClassNames}>
          <Observer>{() => <View vm={vm.searchViewModel} context={searchBarContext} />}</Observer>
        </div>
        {vm.allowWrite && (
          <div className="col-lg-4 col-xxl-3">
            <Observer>{() => <View vm={vm.actionsViewModel} />}</Observer>
          </div>
        )}
      </div>
      <Observer>{() => <View vm={vm.searchViewModel} />}</Observer>
    </div>
  );
});

registerView(CallCenterView, CallCenterViewModel);
